module.exports = __webpack_public_path__ + "img/user-delete.2c975d76.svg";